import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import FacebookIcon from "@mui/icons-material/Facebook";
import { customStyles } from "./index.styles";
import ContactForm from "../../../shared/components/ContactForm";
import { CONTACT_INFO } from "../../../shared/utils/constants";

interface Props {
  id: string;
}

const ContactUs = ({ id }: Props) => {
  return (
    <Box id={id} mb={12}>
      <Container>
        <Box mt={6} mb={4}>
          <Typography variant="h3" sx={customStyles.text}>
            Contact us
          </Typography>
        </Box>

        <Grid container spacing={4} mb={8}>
          {/* Contact Form Section */}
          <Grid item xs={12} md={7}>
            <Card sx={customStyles.formCard}>
              <Typography variant="h5" sx={customStyles.sectionTitle}>
                Send Us a Message
              </Typography>
              <Box mt={3}>
                <ContactForm variant="compact" />
              </Box>
            </Card>
          </Grid>

          {/* Contact Info Section */}
          <Grid item xs={12} md={5}>
            <Card sx={customStyles.infoCard}>
              <Typography variant="h6" sx={customStyles.sectionTitle}>
                Contact Information
              </Typography>

              <Stack spacing={3} mt={3}>
                {/* Email */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                  <Box sx={customStyles.iconWrapper}>
                    <MailOutlineIcon sx={customStyles.contactIcon} />
                  </Box>
                  <Box>
                    <Typography sx={customStyles.contactLabel}>
                      Email
                    </Typography>
                    <Typography
                      component="a"
                      href={`mailto:${CONTACT_INFO.email}`}
                      sx={customStyles.contactValue}
                    >
                      {CONTACT_INFO.email}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                {/* Phone */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                  <Box sx={customStyles.iconWrapper}>
                    <CallIcon sx={customStyles.contactIcon} />
                  </Box>
                  <Box>
                    <Typography sx={customStyles.contactLabel}>
                      Phone
                    </Typography>
                    <Typography
                      component="a"
                      href={`tel:${CONTACT_INFO.phone}`}
                      sx={customStyles.contactValue}
                    >
                      {CONTACT_INFO.phoneDisplay}
                    </Typography>
                  </Box>
                </Box>

                <Divider />

                {/* Facebook */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                  <Box sx={customStyles.iconWrapper}>
                    <FacebookIcon sx={customStyles.contactIcon} />
                  </Box>
                  <Box>
                    <Typography sx={customStyles.contactLabel}>
                      Connect With Us
                    </Typography>
                    <Typography
                      component="a"
                      href={CONTACT_INFO.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={customStyles.contactValue}
                    >
                      Follow us on Facebook
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUs;
